import { render, staticRenderFns } from "./ProfSaudeIcon.vue?vue&type=template&id=314e975f"
import script from "./ProfSaudeIcon.vue?vue&type=script&lang=js"
export * from "./ProfSaudeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports